import { Injectable } from "@angular/core";
import { NestApiProvider, FormDataUpload } from "../../nest-api";
import { Observable } from "rxjs";
import { ResponseData, ResponsePaging } from "../../nest-responses";
import { ResponseListAttendanceMachineDto, RequestSaveAttendanceMachineDto } from "../dto/attendance-machine.dto";

@Injectable()
export class AttendanceMachineApi {

  private readonly service: string = '';
  private readonly model: string = 'attendanceMachine';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public listing(payload: { page: number, limit: number }): Observable<ResponsePaging<ResponseListAttendanceMachineDto>> {
    const method: string = 'GET';
    const func: string = 'listing';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseListAttendanceMachineDto>>(method, url, params, urlParams, body, null);
  }

  public getFileExtension(): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getFileExtension';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null);
  }

  public getAttendanceIdBasedOn(): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getAttendanceIdBasedOn';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null);
  }

  public downloadTemplateAttendanceUpload(queryString: { machineCode: string }): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'downloadTemplateAttendanceUpload';
    const params: any = {};
    const urlParams: any = queryString || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public getFieldType(): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getFieldType';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null);
  }

  public viewTemplateAttendanceUpload(queryString: { machineCode: string }): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'viewTemplateAttendanceUpload';
    const params: any = {};
    const urlParams: any = queryString || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null);
  }

  public getTtamattmachine(): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getTtamattmachine';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null);
  }

  public saveAttendanceMachine(payload: RequestSaveAttendanceMachineDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'saveAttendanceMachine';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null);
  }

  public uploadAttendanceMachine(bodies: FormDataUpload[], queryString: { machineCode: string }): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'uploadAttendanceMachine';
    const urlParams: any = queryString || {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestUpload<ResponseData<any>>(method, url, bodies);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/attendance-machine.api.ts